import { store } from "../store/store";

export const friend = socket => {
  socket.on("friendOnline", ({ id }) => {
    store.commit("chat/friendOnline", id);
  });
  socket.on("friendOffline", ({ id }) => {
    store.commit("chat/friendOffline", id);
  });
};
